import { useState } from 'react';
import axios from 'axios';

const useSaveCostCategorySection = () => {
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState(null);

  const cleanCurrency = (val) => {
    if (val == null || val === '' || val === '$') return null;
    return parseFloat(val.toString().replace('$', '').replace(/,/g, ''));
  };

  const saveSection = async (estimateId, sectionName, rawRows = []) => {
    setLoading(true);
    setError(null);

    try {
      const payload = rawRows.map((row, index) => ({
        estimateId,
        sectionName,
        rowNumber: row.no ?? index + 1,
        account: row.account || '',
        category: row.category || '',
        description: row.description || '',
        pmOverride: row.pmOverride !== '' ? parseFloat(row.pmOverride) : null,
        price: row.price !== '' ? parseFloat(row.price) : null,
        contingencyPercent: row.contingencyPercent !== '' ? parseFloat(row.contingencyPercent) : null,
        contOverridePercent: row.contOverridePercent !== '' ? parseFloat(row.contOverridePercent) : null,
        contingencyCost: cleanCurrency(row.contingencyCost),
        taxRate: row.taxRate !== '' && row.taxRate !== 'n/a' ? parseFloat(row.taxRate) : null,
        taxCost: cleanCurrency(row.taxCost),
        baseCost: cleanCurrency(row.baseCost),
        totalPrice: cleanCurrency(row.totalPrice),
        notes: row.notes || '',
      }));

      await axios.put(`/api/PipelinePricing/pipeline/update-cost-category/${estimateId}`, payload);

      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      console.error('Failed to save:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { saveSection, loading, saved, error };
};

export default useSaveCostCategorySection;
